//USER_MODULE
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGOUT = 'USER_LOGOUT';
export const SET_FACTOR2 = 'SET_FACTOR2';

//INFO_MODULE
export const GET_INFOS_LIST = 'GET_INFOS_LIST';

//AKTA_MODULE
export const GET_AKTAS_LIST = 'GET_AKTAS_LIST';
export const GET_MODAL_AKTAS_LIST = 'GET_MODAL_AKTAS_LIST';

//SESSION_MODULE
export const START_TIMER = 'START_TIMER';
export const STOP_TIMER = 'STOP_TIMER';